export const APIs = {
  BASE_URL: `https://${process.env.REACT_APP_ENV === "PROD" ? "service" : "sbxservice"}.skalillc.com/${
    process.env.REACT_APP_ENV === "PROD" ? "" : "poc/"
  }api`,
  EMS: {
    ListEms: {
      API: "/ems",
      METHOD: "GET",
    },
    GetEms: {
      API: "/ems/{ems-id}",
      METHOD: "GET",
    },
    GetEmsByCognitoUserId: {
      API: "/ems?cognitoUserId={cognito-user-id}",
      METHOD: "GET",
    },
    CreateEms: {
      API: "/ems",
      METHOD: "POST",
    },
    DeleteEms: {
      API: "/ems/{ems-id}",
      METHOD: "DELETE",
    },
    UpdateEms: {
      API: "/ems",
      METHOD: "PATCH",
    },
   
  },
  Passenger: {
     ListPassenger: {
      API: "/passenger?orgId={organizationId}",
      METHOD: "GET",
    },
    GetPassenger: {
      API: "/passenger/{passenger-id}",
      METHOD: "GET",
    },
    CreatePassenger: {
      API: "/passenger",
      METHOD: "POST",
    },
    DeletePassenger: {
      API: "/passenger/{passenger-id}",
      METHOD: "DELETE",
    },
    UpdatePassenger: {
      API: "/passenger",
      METHOD: "PATCH",
    },
  },
  Form: {
    submitForm: {
      API: "/onlineForm",
      METHOD: "POST"
    },
    getAllForms: {
      API: "/verifyForm",
      METHOD: "GET"
    },
    getAllEventReport: {
      API: "/eventReport",
      METHOD: "GET"
    },
    getAllEventReportByOrgId: {
      API: "/eventReport?orgId={orgId}",
      METHOD: "GET"
    },
    getFormDataById: {
      API: "/verifyForm?formId={form-id}",
      METHOD: "GET"
    },
    getAllEventReportById: {
      API: "/eventReport?eventId={event-id}",
      METHOD: "GET"
    },
    approveSelectedFrom: {
      API: "/verifyForm?formId={form_id}&isVerified={is_verified}",
      METHOD: "PATCH"
    },
   
    showMedicalKitData:{
      API: "/medicalKit/itemsByKiType?kitType={kitType}",
      METHOD: "GET"
    },
    createMedicalKit:{
      API: "/medicalKit",
      METHOD: "POST"
    },
    updateItemExpiry:{
      API: "/medicalKit/updateItemExpiry?expiryDate={newDate}&kitId={kitId}&itemId={itemId}",
      METHOD: "PUT"
    },
    reassignMedicalKit:{
      API: "/medicalKit/{kitId}?flightId={flightId}",
      METHOD: "PUT"
    },

    // subscriptionapi

  saveSubscriptionByOrgId: {
    API: "/subscriptions",
    METHOD: "POST"
  },

  getSubscriptionByOrgId: {
    API: "/subscriptions/{orgId}",
    METHOD: "GET"
  },

  getallSubscriptionByOrgId: {
    API: "/subscriptions/logs/{orgId}",
    METHOD: "GET"
  },
  getAllSubscriptions: {
    API: "/subscriptions/all",
    METHOD: "GET"
  },

  // subscriptionapi

    ftfScreening: {
      API: "/ftf/form",
      METHOD: "POST"
    },

    showftfScreening: {
      API: "/ftf/formByOrg",
      METHOD: "GET"
    },

    showftfformbyuploadid: {
      API: "/ftf/formByOrg?formUploadId={uploadid}",
      METHOD: "GET"
    },
    
  },
  Question: {
    listQuestion: {
      API: "/medicalHistory/questions",
      METHOD: "GET",
    },
    addAnswere: {
      API: "/medicalHistory/answers",
      METHOD: "POST"
    },
    getAnswere: {
      API: "/medicalHistory/answers?passengerId={passenger-id}&questionId={question-id}"
    }
  },
  Crew: {
    GetCrewByCognitoUserId: {
      API: "/crew?cognitoUserId={cognito-user-id}",
      METHOD: "GET",
    },
    GetCrew: {
      API: "/crew/{crew-id}",
      METHOD: "GET",
    },
    ResetPassword: {
      API: "/crew/resetpassword",
      METHOD: "PATCH",
    },
    crewList: {
      API: "/crew",
      METHOD: "GET",
    }
  },
  MedicalEmergency: {
    ListMedicalEmergency: {
      API: "/medical?isAdmin={user-admin}",
      METHOD: "GET",
    },
    GetMedicalEmergencyByPassengerId: {
      API: "/medical?passengerId={passenger-id}",
      METHOD: "GET",
    },
    GetMedicalEmergencyByFlightId: {
      API: "/medical?flightId={flight-id}",
      METHOD: "GET",
    },
    GetMedicalEmergenciesByEmsId: {
      API: "/medical?emsId={ems-id}",
      METHOD: "GET",
    },
    GetMedicalEmergencyByStatus: {
      API: "/medical/status/{status}",
      METHOD: "GET",
    },
    GetMedicalEmergency: {
      API: "/medical/get?medicalEmergencyId={medical-emergency-id}",
      METHOD: "GET",
    },
    GetMedicalEmergencyNotes: {
      API: "/medical/{medical-emergency-id}",
      METHOD: "PATCH",
    },
    CreateMedicalEmergency: {
      API: "/medical",
      METHOD: "POST",
    },
    DeleteMedicalEmergency: {
      API: "/medical/{medical-emergency-id}",
      METHOD: "DELETE",
    },
    UpdateMedicalEmergency: {
      API: "/medical",
      METHOD: "PATCH",
    },
    UpdateMedicalEmergencyFields: {
      API: "/medical/{medical-emergency-id}",
      METHOD: "PATCH",
    },
    UpdateMedicalEmergencynotificationEnabler: {
      API: "/medical/get?medicalEmergencyId={medical-emergency-id}&notificationShow={notification-Show}",
      METHOD: "GET",
    },
    recordCall: {
      API: "/medical/recordingStart",
      METHOD: "POST",
    },
    recordCallStop: {
      API: "/medical/recordingStop",
      METHOD: "POST",
    },
    UpdateMedicalEmergencyDiversionStatus: {
      API: "/medical/{medical-emergency-id}",
      METHOD: "PATCH",
    },
    getNewlyIncident: {
      API: "/medical/getNotified?status=NOTIFIED",
      METHOD: "GET",
    },
    getActiveIncident: {
      API: "/medical/getActive?order={order}",
      METHOD: "GET",
    },
    getCrewCurrentLocation: {
      API: "/crewLocation/{crewName}",
      METHOD: "GET"
    },
  

    getActivity: {
      API: "/medical/activeEventsHistory?medicalEmergencyIds={medicalIncidentIds}&assignedEms={assignedEms}&order={order}",
    },
    getAdminActivity: {
      API: "/mixpanel-data?projectId={projId}&fromDate={fdate}&toDate={tdate}&limit=10",
    },
    UserActivity:{
      API: "/medical/getHistory?assignedEms=mleung",
      METHOD : "GET"
    },
    requestReport: {
      API: "/medical/vitalsFlag",
      METHOD: "PUT",
    },
    usernameByCognitoId: {
      API: "/iam/getUserName?cognitoId={cognitoId}",
      METHOD: "GET"
    }
  },
  MedicalKit :{
    getMedicalKit:{
      API : "/medicalKit",
      Method :"GET",
    },
    getCreateKit:{
      API : "/medicalKitItems",
      Method :"GET",
    },
    AddCreateKit:{
      API: "/medicalKit",
      METHOD: "PUT",
    },
    CreateKit:{
      API: "/medicalKit?flightId={flightId}&medicalKitType={item}",
      METHOD: "POST",
    },
    EditKit:{
      API: "/medicalKit/detailsByKitId?id={id}",
      METHOD: "GET",
    },
    UpdateKit:{
      API: "/medicalKit",
      METHOD: "PUT",
    },
    getMedicalKitByOrgId: {
      API: "/medicalKit?orgId={id}",
      METHOD: "GET"
    },
    getMedicalKitPdfLink: {
      API: "/medicalKit?exportKitstoPdf={value}",
      METHOD: "GET"
    }
  },
  MixPannel: {
    ActivityHistory: {
      API: "/mixpanel-data?projectId={projId}&fromDate={fdate}&toDate={tdate}&limit={limit}", // <-- now limit is dynamic
      METHOD: "GET",
    }
  },
  Flight: {
    ListFlight: {
      API: "/flight",
      METHOD: "GET",
    },
    GetFlight: {
      API: "/flight/{flight-id}",
      METHOD: "GET",
    },
    CreateFlight: {
      API: "/flight",
      METHOD: "POST",
    },
    DeleteFlight: {
      API: "/flight/{flight-id}",
      METHOD: "DELETE",
    },
    UpdateFlight: {
      API: "/flight",
      METHOD: "PATCH",
    },
    UpdateFlightDiversionStatus: {
      API: "/flight/{flight-id}?diversionStatus={diversion-status}",
      METHOD: "PATCH",
    },
    UpdateFlightDispositionStatus: {
      API: "/flight/{flight-id}?dispositionStatus={disposition-status}",
      METHOD: "PATCH",
    },
    UpdateFlightLastSeen: {
      API: "/flight/{flight-id}/last-seen",
      METHOD: "PATCH",
    },
    GetFlightByOrgId: {
      API: "/flight/flightByOrganization?organizationId={organization-id}",
      METHOD: "GET",
    },
    GetCrewByFlightId: {
      API: "/flight/crewByFlight?flightId={flight-id}",
      METHOD: "GET",
    },
    GetDropDown:{
      API: "/flight?organizationId={organization-id}",
      METHOD: "GET",
    },
    GetAllFlights:{
      API: "/flight/aircraft",
      METHOD: "GET",
    },
    GetWifiProvider:{
      API: "/flight/wifi-provider",
      METHOD:'GET'
    }
  },

  HmsVideocall: {
    CreateRoom: {
      API: "/hms",
      METHOD: "POST",
    },
    DisableRoom: {
      API: "/hms",
      METHOD: "DELETE",
    },
    GenerateClientToken: {
      API: "/hms/token",
      METHOD: "POST",
    },
  },
  Videcall: {
    ListRecord: {
      API: "/videocall",
      METHOD: "GET",
    },
    getVideoCallRecord: {
      API: "/vcgraph?fromDate={from}&toDate={to}",
      METHOD: "GET",
    },
    GetRecordByVideocallId: {
      API: "/videocall/get?videocallId={videocall-id}",
      METHOD: "GET",
    },
    CreateRecord: {
      API: "/videocall",
      METHOD: "POST",
    },
    DeleteRecord: {
      API: "/videocall/{videocall-id}",
      METHOD: "DELETE",
    },
    UpdateRecord: {
      API: "/videocall",
      METHOD: "PATCH",
    },
    UpdateRecordStatus: {
      API: "/videocall/:videocallId?status={status}",
      METHOD: "PATCH",
    },
    UpdateRecordRoomId: {
      API: "/videocall/:videocallId?roomId={room-id}",
      METHOD: "PATCH",
    },
    ListAllByMedicalEmergencyId: {
      API: "/videocall?medicalEmergencyId={medical-emergency-id}",
      METHOD: "GET",
    },
    InitiatCallData: {
      API: "/vcgraph",
      METHOD: "POST",
    }
  },
  User: {
    ListAllUsers: {
      API: "/iam/user",
      METHOD: "GET",
    },
    ExportPdf: {
      API: "/iam/user?exportPdf=true",
      METHOD: "GET",
      responseType: "blob",
    },
    OrgPdf: {
      API: "/iam/userByOrganization?organizationId={organizationId}&exportPdf=true",
      METHOD: "GET",
      responseType: "blob",
    },
    ListAllUsersByUsername: {
      API: "/iam/user?username={username}",
      METHOD: "GET",
    },
    updateUserAttributesByAdmin: {
      API: "/iam/user",
      METHOD: "PUT",
    },
    updateUserStatus: {
      API: "/iam/user/{username}?isApproved={isApproved}",
      METHOD: "PATCH",
    },
    CreateUser: {
      API: "/iam/user",
      METHOD: "POST",
    },
    AssignRole: {
      API: "/iam/user/{user-id}/role",
      METHOD: "PATCH",
      BODY_TYPE: (body: { roleCode: string }) => body,
    },
    RevokeRole: {
      API: "/iam/user/{user-id}/role/{role-code}",
      METHOD: "DELETE",
    },
    AssignPermission: {
      API: "/iam/user/{user-id}/permission",
      METHOD: "PATCH",
      BODY_TYPE: (body: { permissionCode: string }) => body,
    },
    RevokePermission: {
      API: "/iam/user/{user-id}/permission/{permission-code}",
      METHOD: "DELETE",
    },
    DisableUser: {
      API: "/iam/user/{user-id}",
      METHOD: "DELETE",
    },
    GetUserRoles: {
      API: "/iam/user/{user-id}/roles",
      METHOD: "GET",
    },
    GetOrgById: {
      API: "/iam/user/{user-id}/organization",
      METHOD: "GET",
    },
    GetUserPermissions: {
      API: "/iam/user/{user-id}/permission",
      METHOD: "GET",
    },
    UpdateEmsProfile:{
      API: "/iam/updateEmsProfile",
      METHOD: "PATCH",
    },
    saveDeviceToken: {
      API: "/iam/saveDeviceToken",
      METHOD: "POST",
      BODY_TYPE: (body: { id: string, deviceToken: string | null }) => body,
    },
    getDeviceToken: {
      API: "/iam/userDeviceToken/{username}",
      METHOD: "GET"
    },
    resendEmail: {
      API: "/iam/resendPasswordEmail?username={username}&userEmail={email}",
      METHOD: "POST"
    }
  },
  Organization: {
    ListAllOrganizations: {
      API: "/organization",
      METHOD: "GET",
    },
    CreateOrganization: {
      API: "/organization",
      METHOD: "POST",
    },
    getOrganizationById: {
     API: "/organization/{organization-id}",
      METHOD: "GET",
    },
    // updateOrganizationById: {
    //   API: "/organization/{organization-id}",
    //    METHOD: "PATCH",
    //  },
    getUserByOrganizationId: {
      API: "/iam/userByOrganization/?organizationId={organization-id}",
      METHOD: "GET",
    },
    OrgByUserName: {
      API: "/iam/organization/{username}",
      METHOD: "GET",
    },
    updateOrg: {
      API: '/iam/userOrganization/{username}?organizationId={organization-id}',
      METHOD: "PUT"
    },
    UpdateOrganization: {
      API: "/organization/{id}",
      METHOD: "PATCH",
    },
  },

  Role: {
    ListAllRoles: {
      API: "/iam/roles?search={search}",
      METHOD: "GET",
    },
    CreateRole: {
      API: "/iam/user/role",
      METHOD: "POST",
    },
    GetPermissions: {
      API: "/iam/role/{role-id}/permissions",
      METHOD: "GET",
    },
    DeleteRole: {
      API: "/iam/role/{role-id}",
      METHOD: "DELETE",
    },
    AssignPermission: {
      API: "/iam/role/{role-id}/permission",
      METHOD: "PATCH",
      BODY_TYPE: (body: { permissionCode: string }) => body,
    },
    RevokePermission: {
      API: "/iam/role/{role-id}/permission/{permission-code}",
      METHOD: "DELETE",
    },
    ListAllPermissionForRole: {
      API: "/iam/role/{role-id}/permissions",
      METHOD: "GET",
    },
  },
  Permission: {
    ListAllPermissions: {
      API: "/iam/permissions?search={search}",
      METHOD: "GET",
    },
  },
  Events: {
    ListEvents: {
      API: "/medical/event",
      METHOD: "GET",
    },
    GetEvents: {
      API: "/medical/event/{medical-emergency-id}",
      METHOD: "GET",
    },
    CreateEvents: {
      API: "/medical/event",
      METHOD: "POST",
    },
    DeleteEvents: {
      API: "/medical/event/{event-id}",
      METHOD: "DELETE",
    },
    DeleteAllEvents: {
      API: "/medical/event/medical-emergency/{medical-emergency-id}",
      METHOD: "DELETE",
    },
    UpdateEvents: {
      API: "/medical/event",
      METHOD: "PATCH",
    },
  },
  Endpoint: {
    RegisterEndpoint: {
      API: "/notification-endpoint/register",
      METHOD: "POST",
    },
    RemoveregisterEndpoint: {
      API: "/notification-endpoint/removeUserEndpoint?username={username}",
      METHOD: "PUT",
    },
    GetRegisterEndPoint: {
      API: "/notification-endpoint/userEndpoint?username={username}",
      METHOD: "GET",
    },
    webNotification: {
      API: "/notification-endpoint/send/web",
      METHOD: "POST",
    }
  },
  Report: {
    reportList: {
      API: "/images?medicalEmergencyId=medical_emergency_{medical-emergency-id}",
      METHOD: "GET",
    }
  },
  Medical: {
    getMedicalKit: {
      API: "/medicalKit/scannedKitId?medicalEmergencyId={medical-emergency-id}",
      METHOD: "GET",
    },
    getMedicalKitList: {
      API: "/medicalKit/details/flight/{flightId}?search=",
      METHOD: "GET"
    },
    getNotify: {
      API: "/medicalKit/scannedKitIdFlag?emergencyId={medical-emergency-id}&flag=true",
      METHOD: "PUT",
    },
    getSideData: {
      API: "/medicalKit/{medicalKit}?search=&medicalEmergencyId={medical-emergency-id}",
      METHOD: "GET",
    },
    getAddData: {
      API: "/medicalKit/description?kitId={KitId}&itemId={itemId}&description={description}&medicalEmergencyId={medical-emergency-id}",
      METHOD: "PUT",
    },
    remove: {
      API: "/medicalKit/removeDescription?kitId={KitId}&itemId={itemId}&medicalEmergencyId={medical-emergency-id}",
      METHOD: "PUT",
    },
    getFcmToken: {
      API: "/fcm/fcmtoken",
      METHOD: "",
    }
  },
  FitToFly: {
    SubmitAssessment: {
      API: "/fitToFly/{passengerId}",
      METHOD: "POST",
    },
    GetAssessmentByPassenger: {
      API: "/fitToFly/{passengerId}",
      METHOD: "GET",
    },
  },
};